import { createFileRoute } from "@tanstack/react-router";
import { AuditLog } from "../../../../features/settings/audit/audit-log";

export const Route = createFileRoute("/w/$slug/settings/audit")({ component: AuditLog });
